import { call, put } from 'redux-saga/effects';
import UploadMakeActions from '../redux/UploadMakeRedux';
import { api } from './api';


export function* uploadmakesagas(action: any): Generator<any, void, any> {
  const { withdrawal_id, withdrawal_file } = action;
  const response = yield call(api.uploadMake, withdrawal_id, withdrawal_file);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(UploadMakeActions.uploadMakeSuccess(response.data));
  } else {
    yield put(UploadMakeActions.uploadMakeFailure(response.data));
  }
}